// Helper puro: escolhe o "centro da cidade" a partir dos resultados de um
// reverse-geocode do Google. Fica num módulo separado (sem imports de browser/
// firebase) pra rodar em Node nos specs. Usado por places.geocodeCityCenter
// pra posicionar o pin do dia no centro da cidade (e não em cima do hotel/
// parada), resolvendo a sobreposição de marcadores.

// Dado `results` (Array do geocoder), devolve o {lat,lng} do nível mais
// específico de cidade disponível (locality → postal_town → adm2 → adm1).
// Aceita `location` como número ou como função (.lat()/.lng()) do SDK.
// Retorna null se nenhum nível de cidade tiver coords válidas.
export function pickCityCenter(results) {
  if (!Array.isArray(results)) return null;
  const order = ['locality', 'postal_town', 'administrative_area_level_2', 'administrative_area_level_1'];
  for (const t of order) {
    const r = results.find((x) => Array.isArray(x?.types) && x.types.includes(t));
    const loc = r?.geometry?.location;
    if (!loc) continue;
    const lat = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
    const lng = typeof loc.lng === 'function' ? loc.lng() : loc.lng;
    if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
      return { lat: Number(lat), lng: Number(lng) };
    }
  }
  return null;
}
